import { useLocation, useNavigate } from 'react-router-dom';
import { MenuRounded } from '@mui/icons-material';
import useHeaderStyles from './useHeaderStyles';
import useHeader from '../../hooks/useHeader';
import useGlobalStyles from '../useGlobalStyles';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { searchStringSelector } from '../../redux/slices/questionsSlice';
import {
  headerTitleSelector,
  setSidebarOpen,
  sidebarOpenSelector,
} from '../../redux/slices/layoutSlice';

/**
 * Header component that renders the main title and a search bar.
 * The search bar allows the user to input a query and navigate to the search results page
 * when they press Enter.
 */
const Header = () => {
  const { classes } = useHeaderStyles();
  const { classes: globalClasses } = useGlobalStyles();
  const searchQuery = useAppSelector(searchStringSelector);
  const { handleInputChange, handleKeyDown } = useHeader();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();

  const sidebarOpen = useAppSelector(sidebarOpenSelector);
  const headerTitle = useAppSelector(headerTitleSelector);

  const handleLogoClick = () => {
    if (!location.pathname.includes('/home')) navigate('/home');
    dispatch(setSidebarOpen(false));
  };

  return (
    <div className={classes.header}>
      <div className={classes.logoContainer}>
        <img
          src={`${process.env.PUBLIC_URL}/assets/branding/logo.png`}
          alt='Logo'
          className={classes.logo}
          onClick={handleLogoClick}></img>
      </div>
      <span className={classes.title}>{headerTitle}</span>
      <div className={classes.menuAndSearchContainer}>
        <input
          id='searchBar'
          placeholder={`🔍 Search ...`}
          type='text'
          value={
            searchQuery.length &&
            searchQuery[0] !== '[' &&
            searchQuery[searchQuery.length - 1] !== ']'
              ? searchQuery
              : ''
          }
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          className={`${globalClasses.input}`}
          onClick={() => dispatch(setSidebarOpen(false))}
        />
        <MenuRounded
          className={classes.menu}
          fontSize='large'
          onClick={() => dispatch(setSidebarOpen(!sidebarOpen))}
        />
      </div>
    </div>
  );
};

export default Header;
